var _excluded = ["children", "hideCloseButton", "title", "icon", "description", "actionProps", "backProps", "footerText", "closeButtonSize", "showArrow", "placement", "data-testid"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { FloatingArrow } from '@floating-ui/react';
import { useRef } from 'react';
import { getThemeSpacingAsNumber } from '../../../theme/foundations/spaces';
import { forwardRef, useTestId } from '../../../utils';
import { useMultiStyleConfig } from '../../../utils/use-style-config';
import { Box } from '../Box';
import { edgesPlacements, PopoverContext, usePopover } from './basePopover.utils';
import { BasePopoverBody, BasePopoverContent, BasePopoverFooter, BasePopoverTrigger } from './components';
import { BasePopoverClose } from './components/BasePopoverClose';
import { BasePopoverHeader } from './components/BasePopoverHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var BasePopover = forwardRef((_ref, ref) => {
  var {
    children,
    hideCloseButton = false,
    title,
    icon,
    description,
    actionProps,
    backProps,
    footerText,
    closeButtonSize,
    showArrow = true,
    placement = 'top',
    'data-testid': dataTestId = 'base-popover'
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var arrowRef = useRef(null);
  var popover = usePopover(_objectSpread(_objectSpread({}, props), {}, {
    placement,
    showArrow,
    arrowRef
  }));
  var headerProps = title || icon ? {
    title,
    icon
  } : undefined;
  var shouldShowCloseButton = props.triggerEvent === 'click' && !hideCloseButton;
  var styles = useMultiStyleConfig('BasePopover', {});
  var getTestId = useTestId(dataTestId);

  var getDataComponent = childName => [props['data-component'] || 'BasePopover', childName].filter(Boolean).join('');

  var handleFooterActionClick = e => {
    var _actionProps$onClick;

    popover.setIsOpen(false, 'cta');
    actionProps === null || actionProps === void 0 ? void 0 : (_actionProps$onClick = actionProps.onClick) === null || _actionProps$onClick === void 0 ? void 0 : _actionProps$onClick.call(actionProps, e);
  };

  return /*#__PURE__*/_jsxs(PopoverContext.Provider, {
    value: popover,
    children: [/*#__PURE__*/_jsx(BasePopoverTrigger, {
      "data-component": getDataComponent('Trigger'),
      children: children
    }), /*#__PURE__*/_jsxs(BasePopoverContent, _objectSpread(_objectSpread({
      ref: ref
    }, getTestId()), {}, {
      "data-component": getDataComponent('Content'),
      children: [shouldShowCloseButton && /*#__PURE__*/_jsx(BasePopoverClose, _objectSpread(_objectSpread({}, getTestId('close')), {}, {
        "data-component": getDataComponent('Close'),
        onClose: () => popover.setIsOpen(false, 'close'),
        closeButtonSize: closeButtonSize
      })), headerProps && /*#__PURE__*/_jsx(BasePopoverHeader, _objectSpread(_objectSpread({}, headerProps), {}, {
        "data-component": getDataComponent('Header')
      })), /*#__PURE__*/_jsx(BasePopoverBody, {
        "data-component": getDataComponent('Body'),
        children: description
      }), /*#__PURE__*/_jsx(BasePopoverFooter, _objectSpread(_objectSpread({
        actionProps: {
          label: actionProps === null || actionProps === void 0 ? void 0 : actionProps.label,
          onClick: handleFooterActionClick
        },
        backProps: backProps,
        footerText: footerText
      }, getTestId('footer')), {}, {
        "data-component": getDataComponent('Footer')
      })), showArrow && /*#__PURE__*/_jsx(Box, {
        __css: styles['arrow'],
        as: FloatingArrow,
        ref: arrowRef // ts-ignore is used due to `context` issues with `<Box/>`.
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        ,
        context: popover.context,
        tipRadius: 1,
        staticOffset: edgesPlacements.includes(placement) ? getThemeSpacingAsNumber('s') : undefined
      })]
    }))]
  });
});
BasePopover.displayName = 'BasePopover';
//# sourceMappingURL=BasePopover.js.map